import { gql } from "graphql-tag"

const typeBrand = gql`
  type Brand {
    name: String
  }

  type Query {
    brands: [Brand]
  }
`

export { typeBrand }

export default typeBrand
